import React, { useEffect, useState, useCallback } from "react";
import { message } from "antd";
import { API } from "../../../Config";
import { GET } from "../../../Config/ApiRequests";
import LoadingBox from "../../../Components/LoadingBox";
import SalePendingDataTable from "./SalePendingDataTable";
import MenuBar from "./MenuBar";

function SalePending({ 
  dateFrom, 
  dateTo, 
  user_id, 
  paid_status, 
  search,
  onFilter,
  pageConfig,
  onPageChange 
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({});
  const [meta, setMeta] = useState({});

  const fetchData = useCallback(
    async () => {
      setIsLoading(true);
      try {
        let url = `${API.SALE_OUTSTANDING_REPORT}?page=${pageConfig.page}&take=${pageConfig.take}`;
        
        if (dateFrom) {
          url += `&dateFrom=${dateFrom}`;
        }
        
        if (dateTo) {
          url += `&dateTo=${dateTo}`;
        }
        
        if (user_id) {
          url += `&user_id=${user_id}`;
        }
        
        if (paid_status) {
          url += `&paid_status=${paid_status}`;
        }

        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }

        const response = await GET(url);

        if (response) {
          setData(response.data || []);
          setTotals(response.totals || {});
          setMeta(response.meta || {});
        }
      } catch (error) {
        console.error("Error fetching sale pending report:", error);
        message.error("Failed to fetch sale pending report");
      } finally {
        setIsLoading(false);
      }
    },
    [pageConfig.page, pageConfig.take, dateFrom, dateTo, user_id, paid_status, search]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div>
      <MenuBar
        dateFrom={dateFrom}
        dateTo={dateTo}
        user_id={user_id}
        paid_status={paid_status}
        search={search}
        onFilter={onFilter}
        showUserDropdown={false}
        showSearch={true}
      />
      {isLoading ? (
        <LoadingBox />
      ) : (
        <SalePendingDataTable
          data={data}
          totals={totals}
          meta={meta}
          onPageChange={onPageChange}
          loading={isLoading}
        />
      )}
    </div>
  );
}

export default SalePending;

